// extracted by css-extract-rspack-plugin
export default {"cls1":"download_preflight-cls1_9DZ","cls2":"download_preflight-cls2_Yx7 download_preflight-cls1_9DZ"};